import * as yup from 'yup'
import { Entities } from '../../entities/api/entities'
import { Paymethods } from '../../entities/api/paymethods'

const safeString = (isTitle = false) =>
	yup
		.string()
		.transform((_, originalValue) => {
			if (typeof originalValue !== 'string') return undefined
			const trimmed = originalValue.trim()
			return trimmed === '' ? undefined : trimmed
		})
		.max(isTitle ? 500 : 300)
		.min(1)
		.notRequired()

const booleanSafe = yup
	.boolean()
	.transform((value, originalValue) => (originalValue === '' ? false : value))
	.notRequired()

const shippingInfoSchema = yup.object({
	type: yup
		.mixed<Paymethods>()
		.oneOf(Object.values(Paymethods), 'Método de pago no válido')
		.optional(),
	price: yup
		.number()
		.min(0, 'El precio no puede ser negativo')
		.max(999999, 'El precio es demasiado alto'),
})

const generalDetailsSchema = yup.object({
	brand: safeString(),
	principal_supplement: safeString(),
	type: safeString(),
	model: safeString(),
	age: safeString(),
	gender: safeString(),
	materials: safeString(),
	nutrition_plan: booleanSafe,
	training_plan: booleanSafe,
	duration: safeString(),
	modality: safeString(),
	place: safeString(),
})

const specificationsSchema = yup.object({
	is_gluten_free: booleanSafe,
	is_vegan: booleanSafe,
	have_lactose: booleanSafe,
	is_non_slip: booleanSafe,
	is_adjustable: booleanSafe,
})

const buyFormatSchema = yup.object({
	suplement_format: safeString(),
	container_type: safeString(),
})

const nutritionalInformationSchema = yup.object({
	ingredients: yup
		.string()
		.transform((_, originalValue) => {
			if (typeof originalValue !== 'string') return undefined
			const trimmed = originalValue.trim()
			return trimmed === '' ? undefined : trimmed
		})
		.max(500, 'Los ingredientes deben tener máximo 120 caracteres') 
		.min(1, 'Los ingredientes son obligatorios')
		.notRequired(), 
	nutritional_portion_value: safeString(),
	portion_weight: safeString(),
})

const detailsSchema = yup.object({
	general_details: generalDetailsSchema.required(
		'Los detalles generales son obligatorios'
	),
	specifications: specificationsSchema.notRequired(),
	buy_format: buyFormatSchema.notRequired(),
	nutritional_information: nutritionalInformationSchema.notRequired(),
})

export const productsSchema = yup
	.object({
		type: yup
			.mixed<Entities>()
			.oneOf(Object.values(Entities), 'Tipo de producto no válido')
			.required('Debes seleccionar el tipo'),
		shipping_info: shippingInfoSchema.required(),
		category: safeString(),
		name: safeString(true).required('El nombre es obligatorio'),
		description: yup
			.string()
			.min(20)
			.max(500)
			.required('La descripción es obligatoria'),
		discount: yup
			.number()
			.min(0, 'El descuento mínimo es 0%')
			.max(100, 'El descuento máximo es 100%')
			.notRequired(),
		brand: safeString().required('La marca es obligatoria'),
		active: yup
			.boolean()
			.transform((value, originalValue) =>
				originalValue === '' ? false : value
			)
			.required('El campo estado es obligatorio'),
		details: detailsSchema.required(),
	})
	.defined()

export type ProductFormValues = yup.InferType<typeof productsSchema>